import React, {Component} from 'react'
import LabelEditForm from "./form/edit.component.jsx"
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import SideBar from '../common/layout/sidebar.component.jsx'

class LabelEdit extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            label: {},
            labelTitle: '',
            form: '',
        }
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')

        const labelId = this.props.match.params.labelId
        AppContext.getApiClient().get('/labels/' + labelId).then((label) => {
            const labelForm = <LabelEditForm label={label} />
            this.setState({
                labelTitle: label.attributes.title,
                form: labelForm
            })
        });
    }

    render() {
        return (
            <div>
                {this.state.form}
            </div>
        );
    }
}

export default LabelEdit


// WEBPACK FOOTER //
// ./src/label/edit.component.jsx